"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GenesysSupportCenter = void 0;
var _react = require("react");
var _GenesysSupportCenterSkeleton = require("../GenesysSupportCenterSkeleton");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Uses genesys script to render the support center.
 * Script is loaded by WebMessenger on first render due to preloadGenesysScript setting in Next page.
 * Script renders the support center to div with id "genesys-support-center" instead of GenesysSupportCenterSkeleton inside of it.
 */ const GenesysSupportCenter = (param)=>{
    let { hideWebMessenger } = param;
    const ref = (0, _react.useRef)(null);
    (0, _hooks.useReplaceTextWithTranslations)(ref);
    (0, _hooks.useHideWebMessenger)({
        hideWebMessenger,
        ref
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        ref: ref,
        id: "genesys-support-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_GenesysSupportCenterSkeleton.GenesysSupportCenterSkeleton, {})
    });
};
exports.GenesysSupportCenter = GenesysSupportCenter;
